import FilterChip from './FilterChip';
import FilterOptionsDropdown from './FilterOptionsDropdown';
import { FilterChipProps } from '../../types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useRef } from 'react';

const FilterWithDropdown = ({ type, icon, label }: FilterChipProps) => {
  const quickFilter = useSelector((state: any) => state.map.quickFilter);
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const wrapperRef = useRef(null);

  return (
    <Wrapper dropdownOpen={quickFilter === type && !isMobile} ref={wrapperRef}>
      <FilterChip type={type} icon={icon} label={label} />

      {quickFilter === type && type !== 'nawy_now' && !isMobile && (
        <FilterOptionsDropdown />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ dropdownOpen: boolean }>`
  position: relative;
  min-height: ${props => (props.dropdownOpen ? '600px' : 'auto')};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export default FilterWithDropdown;
